
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/worldcasino-pro",
      function () {
        return require("private-next-pages/worldcasino-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/worldcasino-pro"])
      });
    }
  